import React, { useState } from 'react';
import MyContext from './MyContext';


const LocationProvider = ({ children }) => {
    
  const [locationID, setLocationID] = useState(null);
  return (
    <MyContext.Provider value={{ locationID, setLocationID }}>
      {children}
    </MyContext.Provider>
  );
};

export default LocationProvider;
